const appendScript: (src: string) => void = async src => {
  if (document.querySelectorAll(`script[src="${src}"]`).length) {
    return
  }

  const tag = document.createElement('script')
  tag.src = src
  tag.async = true
  document.body.appendChild(tag)
}

export default appendScript
